"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactiveEnvelope = void 0;
const lodash_1 = __importDefault(require("lodash"));
const moment_1 = __importDefault(require("moment"));
const mobx_1 = require("mobx");
const enums_1 = require("../types/enums");
const consts_1 = require("../consts");
function _getDetailsIfMissing(envelopeType) {
    return consts_1.ENVELOPES_DEFAULT_DETAILS[envelopeType];
}
class ReactiveEnvelope {
    constructor(envelope, updatedAt) {
        this.id = envelope.id;
        this.type = envelope.type;
        this.actuals = envelope.actuals || [];
        this.details = envelope.details || _getDetailsIfMissing(envelope.type);
        this.originalAmount = envelope.originalAmount;
        this.predictedAmount = envelope.originalAmount;
        this.isCustomPrediction = envelope.isCustomPrediction;
        this.balanceDate = envelope.balanceDate;
        this.updatedAt = updatedAt;
        this.sequenceCustomerComment = envelope.sequenceCustomerComment;
    }
    get actualsAmount() {
        const outSum = lodash_1.default.sum(lodash_1.default.map(this.actuals, a => a.billingAmount || 0));
        const inSum = lodash_1.default.sum(lodash_1.default.map(this.actuals, a => a.incomeAmount || 0));
        return outSum - inSum;
    }
    get hasActuals() {
        return this.actuals.length > 0;
    }
    get actualsExceedPrediction() {
        return Math.abs(this.actualsAmount) > Math.abs(this.predictedAmount);
    }
    get balanceDatePassed() {
        return moment_1.default(this.updatedAt) > moment_1.default(this.balanceDate);
    }
    get shouldBalance() {
        const balanceDatePassed = this.balanceDate && this.balanceDatePassed;
        const fixedAndFilled = (this.type === enums_1.EnvelopeType.Fixed || this.type === enums_1.EnvelopeType.RollingCredit) && this.hasActuals;
        const exceededPrediction = this.actualsExceedPrediction;
        return balanceDatePassed || fixedAndFilled || exceededPrediction;
    }
    get balancedAmount() {
        const { actualsAmount } = this;
        return this.shouldBalance ? actualsAmount : this.predictedAmount;
    }
    get isExpense() {
        return this.predictedAmount >= 0 && (this.details && !this.details.isIncome);
    }
    get cashculation() {
        return {
            type: this.type,
            originalAmount: this.predictedAmount,
            balancedAmount: this.balancedAmount,
            actualsAmount: this.actualsAmount,
            balanceDate: this.balanceDate,
            id: this.id,
            balanceDatePassed: this.balanceDatePassed,
            details: lodash_1.default.cloneDeep(this.details),
            isCustomPrediction: this.isCustomPrediction,
        };
    }
    toJson() {
        return {
            type: this.type,
            details: lodash_1.default.cloneDeep(this.details),
            actuals: lodash_1.default.cloneDeep(this.actuals),
            originalAmount: this.predictedAmount,
            balancedAmount: this.balancedAmount,
            balanceDate: this.balanceDate,
            id: this.id,
            balanceDatePassed: this.balanceDatePassed,
            isCustomPrediction: this.isCustomPrediction,
            sequenceCustomerComment: this.sequenceCustomerComment,
        };
    }
}
__decorate([
    mobx_1.observable
], ReactiveEnvelope.prototype, "id", void 0);
__decorate([
    mobx_1.observable
], ReactiveEnvelope.prototype, "type", void 0);
__decorate([
    mobx_1.observable
], ReactiveEnvelope.prototype, "actuals", void 0);
__decorate([
    mobx_1.observable
], ReactiveEnvelope.prototype, "details", void 0);
__decorate([
    mobx_1.observable
], ReactiveEnvelope.prototype, "predictedAmount", void 0);
__decorate([
    mobx_1.observable
], ReactiveEnvelope.prototype, "isCustomPrediction", void 0);
__decorate([
    mobx_1.observable
], ReactiveEnvelope.prototype, "balanceDate", void 0);
__decorate([
    mobx_1.observable
], ReactiveEnvelope.prototype, "updatedAt", void 0);
__decorate([
    mobx_1.observable
], ReactiveEnvelope.prototype, "sequenceCustomerComment", void 0);
__decorate([
    mobx_1.computed
], ReactiveEnvelope.prototype, "actualsAmount", null);
__decorate([
    mobx_1.computed
], ReactiveEnvelope.prototype, "hasActuals", null);
__decorate([
    mobx_1.computed
], ReactiveEnvelope.prototype, "actualsExceedPrediction", null);
__decorate([
    mobx_1.computed
], ReactiveEnvelope.prototype, "balanceDatePassed", null);
__decorate([
    mobx_1.computed
], ReactiveEnvelope.prototype, "shouldBalance", null);
__decorate([
    mobx_1.computed
], ReactiveEnvelope.prototype, "balancedAmount", null);
__decorate([
    mobx_1.computed
], ReactiveEnvelope.prototype, "isExpense", null);
__decorate([
    mobx_1.computed
], ReactiveEnvelope.prototype, "cashculation", null);
exports.ReactiveEnvelope = ReactiveEnvelope;
//# sourceMappingURL=envelope.js.map